import Model from 'flarum/common/Model';
export default class StatusPage extends Model {
  name = (() => Model.attribute('name'))();
  slug = (() => Model.attribute('slug'))();
  logoUrl = (() => Model.attribute('logoUrl'))();
  faviconUrl = (() => Model.attribute('faviconUrl'))();
  navLinks = (() => Model.attribute('navLinks'))();
  description = (() => Model.attribute('description'))();
  websiteUrl = (() => Model.attribute('websiteUrl'))();
  privacy = (() => Model.attribute('privacy'))();
  themeColor = (() => Model.attribute('themeColor'))();
  theme = (() => Model.attribute('theme'))();
  layout = (() => Model.attribute('layout'))();
  themeOverrides = (() => Model.attribute('themeOverrides'))();
  timezone = (() => Model.attribute('timezone'))();
  subscribersEnabled = (() => Model.attribute('subscribersEnabled'))();
  hidePoweredBy = (() => Model.attribute('hidePoweredBy'))();
  noindex = (() => Model.attribute('noindex'))();
  domain = (() => Model.attribute('domain'))();
  domainVerified = (() => Model.attribute('domainVerified'))();
  domainVerifyToken = (() => Model.attribute('domainVerifyToken'))();
  // Ownership proven vs. actually reachable are different things: a verified
  // domain with no certificate resolves and then fails the TLS handshake.
  certificateStatus = (() => Model.attribute('certificateStatus'))();
  domainServing = (() => Model.attribute('domainServing'))();
  subscriberCount = (() => Model.attribute('subscriberCount'))();
  monitorIds = (() => Model.attribute('monitorIds'))();
  monitorSections = (() => Model.attribute('monitorSections'))();
  publicUrl = (() => Model.attribute('publicUrl'))();
  createdAt = (() => Model.attribute('createdAt', Model.transformDate))();
}
flarum.reg.add('linkrobins-lr-monitoring', 'models/StatusPage', StatusPage);